import React, { useEffect } from "react";
import "./input.css";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { ThunkDispatch } from "redux-thunk";
import { IStoreState } from "../../Store";
import { signOut } from "../SignIn/actions";
import { signUp } from "./actions";
import { IRemoteData, IAuth, IEnvironment } from "../../../interface/IShareInfo";

import {
  ISignupPayloadAddress,
  ISignupPayload,
  IPreSignupPayload,
  ISignupState
} from "./ISignup";
import {
  Typography,
  makeStyles,
  createStyles,
  Link,
} from "@material-ui/core";

import { ITheme } from "../../Layout/themes";
import {SlForm, StxInternationalPhoneField, StxInput, StxCheckbox, StxButton } from "../../../../stencil-wrapper";
// import { ContactSupportOutlined } from "@material-ui/icons";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    root: {
      paddingTop: 20,
      [breakpoints.down("sm")]: {
        paddingTop: 10
      }
    },
    title: {
      textAlign: "center",
      color: "#001828",
      marginBottom: "1em"
    },
    subTitle: {
      textAlign: "center",
      color: "#171717",
      marginTop: 20,
      marginBottom: 20
    },
    inputField: {
      marginBottom: 20
    },
    checkboxes: {
      marginTop: 40
    },
    formControlLabel: {
      marginTop: 20,
      marginRight: 0
    },
    formControlLabelRoot: {
      alignItems: "flex-start"
    },
    requiredText: {
      fontSize: "1rem",
      color: palette.text.primary
    },
    btnBox: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: 20,
      marginTop: 20,
      [breakpoints.down("sm")]: {
        flexDirection: "column"
      }
    },
    forgotPasswordLink: {
      display: "flex",
      alignItems: "center",
      [breakpoints.down("sm")]: {
        order: 2,
        marginTop: 32,
        justifyContent: "center"
      }
    },
    linkText: {
      fontWeight: 600,
      cursor: "pointer"
    },
    haveAccountBox: {
      display: "flex",
      height: 60,
      justifyContent: "center",
      alignItems: "center",
      borderTop: "1px solid #dbdbdb"
    },
    textFieldInputLabel: {
      fontSize: "1rem"
    },
    textFieldInputShowText: {
      color: palette.primary.main,
      fontWeight: 600,
      cursor: "pointer"
    },
    phoneFieldBox: {
      width: "calc(100% - 113px - 5px)",
      marginLeft: 5,
      marginTop: 20
    },
    errorMessage: {
      paddingLeft: 26,
      color: palette.error.light
    },
    checkLineContainer: {
      display: "flex",
      marginTop: 20
    },
    checkLineText: {
      paddingRight: 5
    }
  });
});

export interface IProps extends RouteComponentProps {
  createUser: (payload: ISignupPayload) => void;
  resetAuth: () => void;
  auth: IRemoteData<IAuth>;
  env: IEnvironment;
}

export const SignUpComponent = ({
  createUser,
  resetAuth,
  auth,
  history,
  location,
  env
}: IProps) => {
  const classes = useStyles();
 
  useEffect(() => {
    if (auth.data && auth.data.token) {
      const keyIndex = location.search.indexOf("mobiUrl=");

      if (keyIndex > -1) {
        const newSearch = `${location.search.slice(
          0,
          keyIndex - 1
        )}?${location.search.slice(keyIndex)}`;
        history.push(newSearch.replace("?redirectUrl=", ""));
      } else {
        history.push("/");
      }
    } else {
      if (auth.error) {
        resetAuth();
      }
    }

    return () => {
      if (auth.error) {
        resetAuth();
      }
    };
  }, [auth.data.token]);

  useEffect(() => {
    if (auth.error) {
      window.scroll(0, 0);
    }
  }, [auth.error]);
  
  const checkConfirmEmail = () => {
    const emailField:any = document.getElementById("email"),
          confirmationField:any = document.getElementById("emailConfirm");
    if(emailField.value != confirmationField.value) {
      emailField.setAttribute("invalid", "true");
      confirmationField.setAttribute("invalid", "true");
      confirmationField.setAttribute("help-text", "Your email address must match your confirmation");
    } else {
      emailField.removeAttribute("invalid");
      confirmationField.removeAttribute("invalid");
      confirmationField.setAttribute("help-text", "Your email address matches");
    }
  }
  
  const handleSubmit = function (e) {
    let data: any = Object.fromEntries(e.detail.formData)
    let t : any = {
      userName: data.emailConfirm,
      password: data.password,
      emailAddress: data.emailConfirm,
      firstName: data.firstName,
      lastName: data.lastName,
      phones: [{type: 'Mobile', number: data.phone}],
      optIns: [
        {id: "1", selected: data.checkAlert},
        {id: "2", selected: data.checkDiscount},
        {id: "3", selected: data.checkPurkle}
      ],
      consents: [
        {id: "1", selected: data.checkTC}
      ]
    };
    // Hack to cover the missing phone value bug
    if(t.phones[0].number == "") {
      var phoneField:any = document.getElementById("phone");
      t.phones[0].number = phoneField.getAttribute("value");
    }
    createUser(t);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h1" className={classes.title}>
        Create account
      </Typography>
      <SlForm className="signup-form" onSl-submit={(e) => handleSubmit(e)}  >
        <StxInput
          id="firstName"
          name="firstName"
          label="First name*"
          pattern="[A-Za-z]+"
          help-text="Enter your first name"
          className={classes.inputField + " stx-input"}
          autofocus={true}
          required
        />
        <StxInput
          id="lastName"
          name="lastName"
          label="Last name*"
          className={classes.inputField + " stx-input"}
          help-text="Enter your surname"
          pattern="[A-Za-z]+"
          required
        />
        <StxInternationalPhoneField
          id="phone"
          name="phone"
          preferred-countries="AU,NZ"
          label="Phone Number*"
          help-text="Enter your phone number (use the dropdown to select your area code)"
          className={classes.inputField + " stx-input"}
        >
        </StxInternationalPhoneField>
        <StxInput
          id="email"
          name="email"
          type="email"
          label="Email*"
          required
          help-text="Enter your email address"
          className={classes.inputField + " stx-input"}
        />

        <StxInput
          id="emailConfirm"
          name="emailConfirm"
          label="Confirm email*"
          type="email"
          required
          help-text="Confirm your email address"
          onInput={checkConfirmEmail}
          className={classes.inputField + " stx-input"}
        />
        <StxInput
          id="password"
          name="password"
          label="Password*"
          type="password"
          help-text="Password must be between 8 and 32 characters long, with one uppercase letter, one lowercase letter, and one numeral."
          pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$"
          required
          toggle-password
          className={classes.inputField + " stx-input"}
        />
        <StxCheckbox
          name="checkDiscount"
          id="checkDiscount"
          value="true"
          className={classes.inputField + " stx-input"}
        >
          Yes, tell me about pre-sales, discounts, offers, and the latest
        </StxCheckbox>
        
        <StxCheckbox
          id="checkAlert"
          name="checkAlert"
          value="true"
          className={classes.inputField + " stx-input"}
        >
          Yes, I would like to receive mobile alerts and special offers from Ticketek.
        </StxCheckbox>
        <StxCheckbox
          name="checkPurkle"
          id="checkPurkle"
          value="true"
          className={classes.inputField + " stx-input"}
        >
          Yes! I want to join Purkle to earn eVouchers when respoinding to surveys and receive special offers by email.  {" "}         
        <Link
          href={env.PURKLE_COLLECTION_STATEMENT_URL}
          target="_blank"
          rel="noreferrer"
        >
          Collection Statement
        </Link>
        ,{" "}
        <Link
          href={env.PURKLE_TERMS_CONDITIONS_URL}
          target="_blank"
          rel="noreferrer"
        >
          Terms and Conditions
        </Link>
        , and{" "}
        <Link
          href={env.PURKLE_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </Link>
        .
        </StxCheckbox>        
      
        <StxCheckbox
          name="checkTC"
          id="checkTC"
          value="true"
          required
          className={classes.inputField + " stx-input"}
        >      
          I have read and accept the terms of Ticketek’s{" "}
        <Link
          href={env.PRIVACY_POLICY_URL}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          href={env.COLLECTION_STATEMENT_URL}
          target="_blank"
          rel="noreferrer"
        >
          Collection Statement
        </Link>
        *
      </StxCheckbox>
      <StxButton submit type="primary">Sign Up</StxButton>
    </SlForm>

  </div>
)
};

const mapStateToProps = (state: IStoreState) => {
  return {
    auth: state.authData
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    createUser: (payload: ISignupPayload) => dispatch(signUp(payload)),
    resetAuth: () => dispatch(signOut())
  };
};

export const SignUp = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SignUpComponent));